const ProfileClientReviewsEmpty = ({ name }) => {
    return (
        <div className='px-10 pb-10 pt-8 text-center'>
            No reviews yet for <strong>{ name }</strong>.
        </div>
    );
};

export default ProfileClientReviewsEmpty;
